export const SalesStatus = {
  AVAILABLE: 'available',
  SOLD: 'sold',
  NOT_FOR_SALE: 'not for sale',
  INQUIRE_FOR_PRICE: 'inquire for price',
  COMMISSION_AVAILABLE: 'commission available',
  DONATED: 'donated',
} as const;

export const Currencies = {
  KENYA_SHILLING: 'KES',
  US_DOLLAR: 'USD',
};

export const APIs = {
  message: '/api/message',
  collectiveMood: '/api/mood',
  interpretArt: '/api/interpretArt',
  order: '/api/order',
  paintingInquiry: '/api/painting-inquiry',
  communitySignup: '/api/community-signup',
};

export const ArtBookStock = 10;

export const DiscordChannelLink =
  'https://discord.com/channels/1297486504196706384/1297486507640356888';

export const InstagramProfileLink = 'https://www.instagram.com/ethredah.art';
